module.exports = __webpack_public_path__ + "static/img/star.d0ee4a1e.png";